<template>

  
        <DBox
            :id="'cmp-distribution-import-sidewindow-matching'"
            :addButton="false"
            :addLink="false"
            :addLinkLabel="`${$t('add_new')} ${$t('related_track')}`"
           
            :rightMenu="[...rightMenu]"
            @menuClick="onRightMenuClick"
          >
            <NTable
                class="dbox1"
                id="distribution-import-sidewindow-matching"
                :config="tableConfig"
                :headers="Headers"
                :items="list"
                @scrollnext="onImportMatchScrollNext"            
            >
            <template v-slot:item="{ item, tdcon }">
                <tr>
                    <td v-bind="tdcon('identifier')">
                        <span @click="onImportMatchClick(item)" class="ut-link ut-text-accent5 txtov" :title="item['identifier']">
                           {{item['identifier']}}
                        </span>

                    </td>
                    <td v-if="currentChannel=='physical'" v-bind="tdcon('format')">
                        <span>{{item['import_format']}}</span>
                    </td>
                    <td v-if="currentChannel=='costs'||currentChannel=='income'" v-bind="tdcon('group')">
                        <span>{{item['cost_group_name']}}</span>
                    </td>
                    <td v-bind="tdcon('artist')">
                        <span>{{item['import_artist']}}</span>
                    </td>
                    <td  v-bind="tdcon('title1')">
                        <span class="txtov">{{item['import_title']}}</span>
                    </td>
                    <td v-bind="tdcon('catalog_no')">
                        <span>{{item['import_cat_no']}}</span>
                    </td>
                    <td v-if="groupByID && currentChannel=='costs'" v-bind="tdcon('cost_pu')">
                        <span>{{item['cost_pu']?parseFloat(item['cost_pu']).toFixed(2):''}}</span>
                    </td>
                    <td v-if="groupByID" v-bind="tdcon('total')">
                        <span>{{item['total']?parseFloat(item['total']).toFixed(2):''}}</span>
                    </td>
                    <td v-bind="tdcon('options')">
                      <img
                        src="static/icons/delete.svg"
                        @click.stop="(e) => onImportMatchDelete(item)"
                        class="dt-icon v5 s2 ut-center"
                        alt
                       />
                    </td>
               
                
                    
                </tr>
            </template>
            </NTable>
         
        </DBox>
  
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from '../../../../plugins/datatable';
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";
import { DistributionStatementService } from '../../services/statement.service';
import { ConfirmationService,createConfirmResult } from '../../../../dt-plugins/confirmation/confirmation.service';
export default {
  props: {

    selectedStatementDetails: {
        type: Object,
    },
  },
  components: {
        NTable,
        DBox,   
  },
  data: function() {
    return {
     textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true
      },
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight:true
      }),
      start:0,
      groupByID:true
  
    };
  },
  computed:{

    currentChannel:function(){
      return this.selectedStatementDetails?.statement?.digital_physical||'';
    },

    rightMenu:function(){
      let menu =  [
        {
          text: this.$t('delete_unmatched'),
          value: 'delete_unmatched',
        },
        {
          text: this.$t('remove_minimal_income'),
          value: 'remove_minimal_income',
        },
        {
          text: this.$t('split_match_unmatch'),
          value: 'split_statement',
        },
        {
          text: this.$t('artist_title_match'),
          value: 'artist_title_match',
        },
        // {
        //   text: this.$t('group_by_identifier'),
        //   value: 'group_by_identifier',
        // },
        {
          text: this.$t('check_supplier_ids'),
          value: 'run_id_match',
        },
      ]
      if(this.currentChannel=='physical'){
        return menu.filter(x=>x.value!='remove_minimal_income' && x.value!='artist_title_match')
      }
      else if(this.currentChannel=='costs'||this.currentChannel=='income'){
        return menu.filter(x=>x.value!='remove_minimal_income' && x.value!='artist_title_match')
      }

      return menu;
    },


    Headers: function () {
      let headers = [
        createTableHeader("identifier", { f:1.8 }),
        createTableHeader("format", { }),
        createTableHeader("group", { }),
        createTableHeader('artist',{}),
        createTableHeader('title1',{ text:'title' ,f:1.3}),
        createTableHeader('catalog_no',{}),
        createTableHeader('total',{ text:false ,mw:100 ,ta:'right'}),
        createTableHeader('options',{text:false,mw:30}),      
      ];

      if(this.currentChannel!='physical'){
        headers = headers.filter(x=>x.value!='format')
      }
      if(this.currentChannel!='costs' && this.currentChannel!='income'){
        headers = headers.filter(x=>x.value!='group')



      }
      if(this.currentChannel=='costs' || this.currentChannel=='income'){
        const location = headers.length;

        headers.splice(location-2,0,createTableHeader('cost_pu',{}),)
        console.log("iiiiiiiiiiiiiiiiii:::::::::::::::",headers)
      }
      // console.log(headers,"::::::::::::headers",this.currentChannel)
      if(this.groupByID){
        
        return headers;
      }else{
        return headers.filter(x=>x.value!='total'&&x.value!='cost_pu')
      }
        

    },

    list:function(){
      return this.selectedStatementDetails.statement_lines||[]
    },
    statement_id: function () {
      return this.selectedStatementDetails.statement.statement_id;
    },


      
  },
  

 
  methods:{
   
  
    onImportMatchDelete:function(item){
      console.log(item)
      this.$emit("delete",item)
    },
    onImportMatchClick:function(item){
      this.$router.push({
        ...this.$route,
        query: {
          modal: 'manual_match_modal',
          statement_line_id:item.statement_line_id,
          channel:this.currentChannel
        },
      });
     console.log("::::",item)
    },

    onRightMenuClick:async function(menu) {
      console.log(menu)
      switch(menu) {
        case 'group_by_identifier': {
          //const statement_lines = await DistributionStatementService.groupByIdentifier(this.statement_id);
          //console.log("change:::",statement_lines)
          this.groupByID=true
          this.$emit("change",{menu:'group_by_identifier',statement_id:this.statement_id})
          break;
        }
        case 'run_id_match': {

          //const statement_lines = await DistributionStatementService.checkSupplierIds(this.statement_id);
          //console.log("change:::",statement_lines)
          const confirmationResult = await ConfirmationService.createP({
                body: `${this.$t('matching_progress')}`,
                results: [
                  createConfirmResult({
                    value: "ok",
                    text: "OK",
                    classes: ["v1 s7"],
                  }),
                ],
              });
          this.$emit("change",{menu:'run_id_match',statement_id:this.statement_id})
          break;
        }
        case 'artist_title_match': {

          //const statement_lines = await DistributionStatementService.checkSupplierIds(this.statement_id);
          //console.log("change:::",statement_lines)

            const confirmationResult = await ConfirmationService.createP({
                body: `${this.$t('update_stmt_artist_title')}`,
                results: [
                  createConfirmResult({
                    value: "ok",
                    text: "OK",
                    classes: ["v1 s7"],
                  }),
                ],
              });

          await DistributionStatementService.updateArtistTitleMatch(this.statement_id)

          //this.$emit("change",{menu:'artist_title_match',statement_id:this.statement_id})
          break;
        }
        case 'delete_unmatched': {

          //const statement_lines = await DistributionStatementService.checkSupplierIds(this.statement_id);
          //console.log("change:::",statement_lines)
          this.$emit("change",{menu:'delete_unmatched',statement_id:this.statement_id})
          // this.$router.push({
          //     ...this.$route,
          //     query: {
          //       modal: 'remove_minimal_income',
          //     },
          //   });
          break;
        }
        case 'remove_minimal_income': {

          //const statement_lines = await DistributionStatementService.checkSupplierIds(this.statement_id);
          //console.log("change:::",statement_lines)

          this.$router.push({
              ...this.$route,
              query: {
                modal: 'remove_minimal_income',
                statement_id:this.statement_id
              },
            });
          break;
        }
        case 'split_statement' :{
          this.$router.push({
              ...this.$route,
              query: {
                modal: 'split_statement_modal',
                statement_id:this.statement_id
              },
          });
        }


      }
    },

    onImportMatchScrollNext:function(value){
        console.log(value,":POOII")
        this.start+=100
        this.$emit('scroll',this.start)
    }
  

  }

}
</script>
<style lang="scss">
.cmp-distribution-import-sidewindow-matching{
  
  .dt-ntable {
    //--ntable-height: 170px;
  }
  .i-icon-box{
    border:1px solid white;
    background-color:var( --emerald) ;
    color:white;
    font-weight: 400;
    display: grid;
    place-items: center;
    
  }



}

  .cmp-catalog-releases-sidewindow-hover_div{
    padding:10px;
    background:white;
    p{
      margin-bottom: 0px;
    }
  }
</style>
